import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { cn } from 'support/helpers/cn/cn';
import { BreadcrumbConfig } from 'support/types/breadcrumbs';

type BreadcrumbItemProps = {
  breadcrumb: BreadcrumbConfig;
  isActive: boolean;
};

export const BreadcrumbItem = ({ breadcrumb, isActive }: BreadcrumbItemProps) => {
  const { t } = useTranslation();

  const commonProps = {
    className: cn(
      isActive ? 'text-gray-700' : 'max-w-64 text-gray-500',
      'truncate text-sm font-medium',
      !isActive && 'hover:text-gray-700',
    ),
  };

  const content = typeof breadcrumb.label === 'string' ? breadcrumb.label : breadcrumb.label(t);

  if (isActive) {
    return (
      <span className="inline-flex items-center gap-2">
        <span aria-current="page" aria-disabled="true" {...commonProps}>
          {content}
        </span>
        {breadcrumb.labelAdornment}
      </span>
    );
  }

  return (
    <span className="inline-flex items-center gap-2">
      <Link to={breadcrumb.to} state={{ keepBreadcrumbs: true }} {...commonProps}>
        {content}
      </Link>
      {breadcrumb.labelAdornment}
    </span>
  );
};
